module.exports = __webpack_public_path__ + "img/abdulrahman_alshari.56fb06be.webp";